import { Injectable, Output, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import swal from "sweetalert2";

@Injectable()
export class HandleError{
      @Output() change = new EventEmitter();
    constructor(private router: Router) { }

    ErrorHandler(error:any){
        
        if (error.status == 401) {
            localStorage.clear();
            this.change.emit(true);
            this.router.navigate(['/login']);
            swal({ title: 'Sorry', text: 'Your current session got expired! Please login again.', type: 'info'});
          }
          /*else
          {
            swal({ title: 'Error', text: 'An error has occurred, please try later.', type: 'error'});
          }*/
    }


}


// WEBPACK FOOTER //
// ./src/app/shared/HandleError.ts